import React from 'react';

const cards = [
    {
      title: 'Sekolah',
      bgColor: 'bg-teal-700',
      intro: '',
      content: [
        'Komunikasi dengan orang tua',
        'Pendaftaran dan pembayaran siswa',
        'Program pemasaran untuk komunitas sekolah',
        'Fasilitas seperti koneksi internet dan listrik',
        'Infrastruktur fisik seperti ruang kelas, set komputer lengkap, headphone, dan proyektor',
      ],
      conclusion: '',
      note: 'Note: Dapat berubah sesuai kesepakatan kerja sama',
    },
    {
      title: 'Accelist Edukasi Indonesia',
      bgColor: 'bg-blue-700',
      intro: '',
      content: [
        'Guru dan pendamping lokal',
        'Kurikulum dan bahan pengajaran',
        'Pelatihan dan pengembangan guru',
        'Dukungan jarak jauh yang berkelanjutan',
        'Perangkat lunak dan platform pembelajaran',
        'Sertifikat, buku kerja, dan materi pengajaran',
        'Pengecekan pencapaian tujuan dan pembuatan sertifikat',
        'Situs web atau platform untuk memamerkan proyek anak-anak',
      ],
      conclusion: '',
      note: 'Note: Dapat berubah sesuai kesepakatan kerja sama',
    },
];


const AboutCard = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap lg:flex-nowrap justify-center gap-4 sm:gap-6 px-4 md:px-8 py-4 md:py-8">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`rounded-2xl shadow-md text-white p-4 w-[350px] h-[550px] ${card.bgColor}`}
        >
          <h3 className="text-lg font-bold text-center mb-2">{card.title}</h3>
          <div className="w-12 border-t-2 border-white mx-auto mb-8" />
          
          {card.intro && <p className="text-base font-semibold mb-2">{card.intro}</p>}
          
          <ul className="text-base text-justify font-semibold space-y-2 pl-6">
            {card.content.map((item, i) => (
              <li key={i} className="list-disc">
                {item}
              </li>
            ))}
          </ul>
          
          {card.conclusion && <p className="text-base font-semibold mt-4">{card.conclusion}</p>}
          
          <p className="mt-6 text-xs font-semibold">{card.note}</p>
        </div>
      ))}
    </div>
  )
}

export default AboutCard